/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

//window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

/*const app = new Vue({
    el: '#app',
});*/



require('./admin/users');
require('./admin/permissions');
require('./admin/role_has_permissions');
require('./admin/roles');
require('./admin/kiosko');

require('./alerts')
require('./abastecimiento/abastecimiento')
require('./user/user')
require('./profile/profile')
require('./reminder')
require('./task')
require('./tickets/support/soporte')
require('./tickets/support/ti')
require('./tickets/support/ticketsTi')
require('./tickets/support/suggestions')
require('./tickets/support/tickets')
require('./global/global_status')
require('./barcode')
require('./tickets/support/reports')
require('./precios/precios')
require('./devoluciones/devoluciones')
require('./returns/returns')
require('./store/store')
require('./transfer/transfer')
require('./transfer/search')
require('./suppliers/suppliers')
require('./search/search')
require('./service/print')


$('.datepicker').datepicker({
    language:'es',
    format: "yyyy-mm-dd",
    orientation: "bottom auto",

});

window.loadingOverlayOptions = {
    image       : "",
    fontawesome : "fa fa-cog fa-spin",
    fontawesomeColor: "#8BD5C8"
};

$('[data-toggle="tooltip"]').tooltip()

$('.chosen-select').chosen({
    width: '100%',
    no_results_text: "No se encontraron resultados para",
    search_contains: true // busca coincidencias en cualquier parte del texto, no solo al inicio
});










